import { createSelector } from "@ngrx/store";
import { PotentialCauseState } from "../reducers/potential-cause.reducer";

export const selectPotentialCauseState = (state: any) => state.potentialCause;

export const selectPotentialCause = createSelector(
    selectPotentialCauseState,
  (state: PotentialCauseState) => state.potentialCause
);

export const selectPotentialCauseLoading = createSelector(
  selectPotentialCauseState,
  (state: PotentialCauseState) =>{
    return  state.loading
  }
);
export const selectPotentialCauseError = createSelector(
  selectPotentialCauseState,
  (state) => state.error
);